module.exports = __webpack_public_path__ + "media/lobby-music2.4ee457ad.mp3";